define('charts/layers/markers',["require", "exports", "../../baseline/colors", "../../tracks/track-state"], function (require, exports, colors, trackState) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Markers = void 0;
    // tslint:disable-next-line:max-line-length
    var markerPath = "M 4.2016313,15.41833 C 2.488485,11.85599 1.1332538,8.67644 0.49495773,6.722 0.33428615,6.23003 0.13192533,5.45813 0.05968479,5.06166 -0.04250982,4.5008 -0.01494569,3.99705 0.15379287,3.34181 0.55709082,1.77572 1.8155259,0.52984 3.3918244,0.13606 3.8387464,0.02442 4.0366688,0 4.4947488,0 5.7060867,0 6.8134278,0.45804 7.6679598,1.31258 8.4787115,2.12333 8.9421662,3.18801 8.9851395,4.33849 9.0009685,4.76227 8.9351925,5.16693 8.7261159,5.93204 8.3296853,7.38277 7.4948234,9.51926 6.2145354,12.35942 5.5944278,13.73504 4.5244779,16 4.4947488,16 4.4873888,16 4.3554811,15.73825 4.2016313,15.41833 Z M 4.9977379,6.41142 C 5.7895883,6.21163 6.3646068,5.5572 6.4767384,4.72816 6.6104314,3.73971 5.9429423,2.77898 4.9561858,2.53959 4.7196834,2.48219 4.2698142,2.48219 4.0333118,2.53959 2.8865451,2.8178 2.2226367,4.02613 2.6063382,5.13672 2.8043091,5.70973 3.2991086,6.19654 3.8667845,6.37681 4.253917,6.49975 4.605055,6.5105 4.9977379,6.41141 Z";
    var Markers = /** @class */ (function () {
        function Markers(track) {
            this.track = track;
        }
        Markers.prototype.init = function (chart) {
            var _this = this;
            this.svgGroup = chart.layers.space.append("g")
                .attr("class", "markers")
                .style("clip-path", "url(#chart-clipping-time)");
            this.exitPin = this.svgGroup.append("path")
                .attr("class", "marker exit")
                .attr("d", markerPath)
                .style("fill", colors.exitColor);
            this.deployPin = this.svgGroup.append("path")
                .attr("class", "marker deploy")
                .attr("d", markerPath)
                .style("fill", colors.deployColor);
            this.landPin = this.svgGroup.append("path")
                .attr("class", "marker landing")
                .attr("d", markerPath)
                .style("fill", colors.landColor);
            trackState.labelUpdates.subscribe(function () { return _this.update(chart); });
        };
        Markers.prototype.update = function (chart) {
            this.dropPin(chart, this.exitPin, this.track.labels.exit);
            this.dropPin(chart, this.deployPin, this.track.labels.deploy);
            this.dropPin(chart, this.landPin, this.track.labels.land);
        };
        Markers.prototype.remove = function () {
            this.svgGroup.remove();
        };
        Markers.prototype.dropPin = function (chart, pin, millis) {
            if (millis !== undefined && millis >= 0) {
                var localTime = this.track.utcToBrowser(millis);
                var sx = chart.xAxis.scale(localTime);
                pin.attr("transform", "translate(" + (sx - 4.5) + "," + (chart.height() - 16) + ")");
                pin.style("display", "");
            }
            else {
                pin.attr("transform", "");
                pin.style("display", "none");
            }
        };
        return Markers;
    }());
    exports.Markers = Markers;
});
//# sourceMappingURL=/assets/javascripts/charts/layers/markers.js.map;
